module.exports = __webpack_public_path__ + "static/media/community-gardens-data-sm.7dd6c72a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/community-gardens-data-sm.jpg
// module id = 153
// module chunks = 13